import { prop, inject, ComponentEventBus } from "fw";

@inject
export class Pager {
    @prop(null) total!: number;
    @prop(null) pageSize!: number;
    @prop(null) page!: number;
    @prop(null) loading!: boolean;
    @prop(true) floating: boolean;

    constructor(private ceb: ComponentEventBus) {}

    get start() {
        return Math.min((this.currentPage - 1) * this.pageSize + 1, this.total);
    }

    get end() {
        return Math.min(this.start - 1 + this.pageSize, this.total);
    }

    get hasPages() {
        return this.total > this.pageSize;
    }

    get canPrev() {
        return this.currentPage > 1;
    }

    get canNext() {
        return this.start + this.pageSize <= this.total;
    }

    get currentPage(): number {
        return this.page || 1;
    }

    prevPage() {
        this.ceb.dispatch("previous");
    }

    nextPage() {
        this.ceb.dispatch("next");
    }
}
